<template>
  <div class="standing adminCargoTransfer">
    <div class="lading_conter_search" id="lading_conter_search-billLading">
      <my-search-query :fromList="fromList" :height="heightSearch" @queryEven="getTableParams(false)" ref="queryList"/>
    </div>
    <div class="standing-bar">
      <search>
        <el-button type="primary" size="small" @click.native="operationInfoEven" icon="el-icon-tickets"> 详情</el-button>
        <el-button @click.native="operationAddEven"
                   type="primary" size="small" icon="el-hg-icon-add"> 新增
        </el-button>
        <el-button type="primary" size="small" @click.native="operationEditEven"
                   :disabled="disableBtnedit" icon="el-hg-icon-edit"> 修改
        </el-button>
        <el-button type="primary" size="small" @click.native="btnConfirm(doOperate,'1','是否审核选中提单？')"
                   :disabled="disableBtncommit" icon="el-hg-icon-audit"> 审核
        </el-button>
        <el-button type="danger" size="small" @click.native="btnConfirm(doOperate,'3','是否作废选中提单？')"
                   icon="el-icon-remove"
                   :disabled="disableBtnDel"> 作废
        </el-button>
        <el-button type="primary" size="small" @click.native="getTableParams(false)" icon="el-icon-refresh"> 刷新
        </el-button>
        <el-button type="primary" size="small" icon="el-icon-upload" @click="$refs.spTable.exportExcel()">导出</el-button>
      </search>
    </div>
    <div class="lading_conter">
      <div class="lading_table">
        <div class="lading_conter_table">
          <sp-table
            ref="spTable"
            :parentTableData.sync="tableData"
            :parentCol.sync="colList"
            :dragDrop=true
            :id-edit="false"
            @addNewData="addNewData"
            :summary-data="summaryData"
            :summary-method="getSummaries"
            show-summary
            @selection-change="handleSelectionChange"
            @getDetail="operationInfoEven"
            width="100%"
            @header-click="headerClickEven"
          >
            <el-table-column align="center" type="selection" class="selection"></el-table-column>
            <el-table-column align="center" type="index" label="序号" width="50" class-name="index"></el-table-column>
            <sp-table-column :align="item.titleAlignment" v-for="(item, index) in colList" :key="`col_${index}`"
                             :width="item.width"
                             :sortable="colList[index].sortableStart"
                             :sort-orders="['ascending','descending',null]"
                             :prop="colList[index].field"
            >
              <template slot="header">
                <p :class="item.field">{{item.title}}</p>
              </template>
              <template v-slot="{ scope }">
                <div :style="{ textAlign: item.alignment}" :class="[initColor(scope.row),'span']">
                  {{item.id ? item.id : item.uid}}
                  {{scope.row[colList[index].field]}}
                </div>
              </template>
            </sp-table-column>
          </sp-table>
        </div>
        <div class="page">
          <page-modle
            :currentPage="currentPage"
            :total="total"
            :pageSize="pageSize"
            @currentChange="currentChange"
            @sizeChange="sizeChange"/>
        </div>
      </div>
    </div>
    <Dialog :title="'请输入手机号'+ Codephone+'收到的验证码'" :width="400"
            :height="100" :visible="msgCodeShow"
            @close="msgCodeShow = !msgCodeShow">
      <div class="grid-contain dialog edit">
        <el-form label-width="80px" style="margin-top: 10%">
          <el-form-item label="验证码" class="required">
            <el-input size="small" v-model="msgCode" placeholder="请输入六位验证码"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" style="width:100%;text-align: right;display: flex;justify-content:center;">
          <el-button size="small" icon="el-hg-icon-save" type="primary" @click="checkMsgCode"
                     style="margin-left: 20px">确定
          </el-button>
        </div>
      </div>
    </Dialog>
  </div>
</template>
<script>
  import {spTable, spTableColumn} from '@/components/sptable';
  import pageModle from '@/views/comm/pagination';
  import mySearchQuery from '../comm/searchQuery';
  import Search from 'views/comm/search';
  import {mapGetters, mapActions} from 'vuex';
  import Dialog from '@/components/dialog';
  import dayjs from 'dayjs';
  import storageM from '@/storage';

  const storage = storageM['sessionStorage'];
  const _ = require('lodash');

  export default {
    name: 'adminCargoTransfer',
    components: {
      spTable,
      spTableColumn,
      mySearchQuery,
      pageModle,
      Search,
      Dialog
    },
    data() {
      return {
        tableData: [],
        bargain: [],
        productNumList: [],
        getTGuestNumList: [],
        getBlno: [],
        getCreator: [],
        heightSearch: 0,
        currentPage: 1,
        pageSize: 10,
        total: 0,
        userChoice: [],
        addOperationStart: false,
        msgCodeShow: false,
        currF: '',
        currFpar: '',
        msgCode: '',
        colList: [],
        itmeState: {
          '0': '已创建',
          '1': '已操作完成',
          '90': '已有效',
          '91': '操作中',
          '100': '已完成',
          '99': '审核中',
          '-1': '已作废',
        },
        billlist: [],
        disableBtnRevoke: false,
        disableBtnDel: false,
        disableBtnedit: false,
        disableBtncommit: false,
        summaryData: '',
        Codephone: '',
      };
    },
    updated() {
      let height = this.$refs.spTable.$el.clientHeight;
      this.heightSearch = height > 592 ? height : 592;
    },
    activated() {
      let start = storage.$get({key: 'cargoTransferTable',});
      if (start) {
        storage.$remove({
          key: 'cargoTransferTable',
        });
        this.getTableParams(false);
      }
    },
    async created() {
      this.CargoTransferAction();
      await this.allQueryAPI();
      this.initCol();
    },
    async mounted() {

    },
    computed: {
      ...mapGetters({
        userInfor: 'user/userInfor',
        CargoTransfer: 'dictionary/CargoTransfer',
        visitedViews: 'tags/visitedViews',
      }),
      fromList() {
        let arr = [
          {
            label: '划入提单号',
            key: 'transferGoodsId',
            valData: this.getBlno,
            type: 'input',
            labelVal: 'BLNO',
            value: 'BLNO',
            colSpan: 8
          },
          {
            label: '产品',
            key: 'goodsId',
            type: 'select',
            showDialog: true,
            tips: '...',
            valData: this.productNumList,
            labelVal: 'Name',
            value: 'GoodsID',
            multiple: false,
            colSpan: 8
          }, {
            label: '划入客户',
            key: 'inGuestId',
            type: 'select',
            showDialog: true,
            tips: '...',
            valData: this.getTGuestNumList,
            labelVal: 'Name',
            value: 'GuestID',
            multiple: false,
            colSpan: 8
          },
          {
            label: '单据状态',
            key: 'state',
            type: 'select',
            valData: this.billlist,
            labelVal: 'value',
            value: 'key',
            multiple: true,
            colSpan: 8
          },
          {
            label: '开始时间',
            key: 'beginDate',
            type: 'timeSelect',
            default: `${this.$utils.getTimeByMonth(new Date(), 1)} 00:00:01`,
            colSpan: 8
          },
          {
            label: '结束时间',
            key: 'endDate',
            type: 'timeSelect',
            default: `${this.$utils.getTimeByDay(new Date())} 23:59:59`,
            colSpan: 8
          },

        ];
        return arr;
      },
    },
    methods: {
      ...mapActions({
        CargoTransferAction: 'dictionary/CargoTransferAction',
      }),
      doOperate(t) {
        switch (t) {
          case '1':
            this.doAudit();
            break;
          case '2':
            this.operationRecallEven();
            break;
          case '3':
            this.operationDeleteEven();
            break;
          default:
            break;
        }
      },
      riskCheck(f, p) {
        this.$services.postLoading({
          type: 'GUESTBUSINESS',
          url: 'getRiskCtrlLevel',
          params: {accountId: this.userInfor.accountId},
        }).then(res => {
          if (res.bean) {
            this.currF = f;
            this.currFpar = p;
            res.bean.riskCtrlLevel == 2 ? this.sendCode() : this.doOperate(f);
          }
        });
      },
      sendCode() {
        if (this.userInfor.phone) {
          this.$services.postLoading({
            type: 'WECHAT',
            url: 'sendSMSCode',
            params: {phoneNumber: this.userInfor.phone},
          }).then(res => {
            if (res.code === '000') {
              this.Codephone = this.userInfor.phone.replace(/^(\d{3})\d{4}(\d+)/, '$1****$2');
              this.msgCodeShow = true;
            }
          });
        }
        else {
          this.$message({
            message: '未维护手机号，不允许下单。请与客服人员联系后重试！',
            type: 'error',
          });
        }
      },
      checkMsgCode() {

        this.$services.postLoading({
          type: 'BUSINESS',
          url: 'checkRefPhone',
          params: {phoneNumber: this.userInfor.phone, SMSCode: this.msgCode},
        }).then(res => {
          if (res.code === '000') {
            this.msgCodeShow = !this.msgCodeShow;
            this.$message({
              message: '校验成功，执行保存',
              type: 'success',
            });
            // this.checkForm();
            this.doOperate(this.currF);
          }
          else {
            this.$message({
              message: '校验失败，请重新输入',
              type: 'error',
            });
          }
        });
      },
      btnConfirm(F, t, str) {
        this.$confirm(str, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if (typeof F === "function") F(t);

        });
      },
      getSummaries(param) {
        const countList = ['TotalNumber', "LeftNumber"];
        const countObj = {
          TotalNumber: {
            unit: ' ',
          }, LeftNumber: {
            unit: ' ',
          },
        };
        const {columns, data} = param;
        let sums = [];
        columns.forEach((column, index) => {
          if (index === 1) {
            sums[index] = '合计';
            return;
          }
          if (countObj[column.property]) {
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                }
                return prev;
              }, 0);
              sums[index] = sums[index].toFixed(3);
              sums[index] += countObj[column.property].unit;
            }
            else {
              sums[index] = '';
            }
          }
        });
        this.summaryData = [countList, sums];
        return sums;
      },
      headerClickEven(column, event) {
        this.colList.forEach((itme, key) => {
          if (column.property === itme.field) {
            !itme.sortableStart ? column.order = 'ascending' : '';
            itme.sortableStart = true;
            if (column.order === null) {
              itme.sortableStart = false;
              column.order = '';
            }
            this.$forceUpdate();
          }
        });
      },
      // 获取单据状态
      getStateList() {
        return new Promise((resolve, rej) => {
          this.$services.post({
            type: 'GUESTBUSINESS',
            url: 'T_State',
            params: {
              accountId: this.userInfor.accountId,
            },
          }).then(res => {
            this.billlist = res.bean;
            resolve();
          });
        });

      },

      initColor(item) {
        const State = {
          10: 'orderState_color10',
          2: 'orderState_color2',
          0: 'orderState_color3',
          '-1': 'orderState_color4',
          99: 'orderState_color5',
          1: 'orderState_color6',
          91: 'orderState_color7',
          100: 'orderState_color1',
        };
        if (item.IsRed === 1) {
          return 'orderState_color8';
        }
        if (State[item.State]) return State[item.State];
        return 'orderState_color9';
      },
      addNewData(callback) {
        this.tableData.push(JSON.parse(JSON.stringify(
          Object.assign({
            uid: this.$utils.getUid(),
          }, this.originData),
        )));
        this.$nextTick(() => {
          callback();
        });
      },
      // 导出事件
      exportEven() {

      },
      // 条件事件集合
      async allQueryAPI() {
        await this.getBargainEven();
        await this.productNum();
        await this.getTGuestNum();
        await this.getStateList();
        await this.getTableParams(false);
      },
      // 合同号弹出选择
      getBargainEven() {
        this.$services.post({
          type: 'GUESTBUSINESS',
          url: 'getBargain',
          params: {
            accountId: this.userInfor.accountId,
          },
        }).then(res => {
          this.bargain = res.bean;
        });
      },
      // 制表人接口
      getCreatorEven() {
        this.$services.post({
          type: 'GUESTBUSINESS',
          url: 'getCreator',
          params: {
            accountId: this.userInfor.accountId,
          },
        }).then(res => {
          this.getCreator = res.bean;
        });
      },
      // page翻页回调
      currentChange(val) {
        this.currentPage = val;
        this.getTableParams(false);
      },
      // 每页显示数据内容变化
      sizeChange(val) {
        this.pageSize = val;
        this.getTableParams(false);
      },
      // 产品编号
      productNum() {
        this.$services.post({
          type: 'GUESTBUSINESS',
          url: 'OW_Web_Get_Goods',
          params: {
            accountId: this.userInfor.accountId,
          },
        }).then(res => {
          this.productNumList = res.bean;
        });
      },
      // 提货人编号
      getTGuestNum() {
        this.$services.post({
          type: 'GUESTBUSINESS',
          url: 'OW_Web_Get_T_Guest',
          params: {
            accountId: this.userInfor.accountId,
          },
        }).then(res => {
          this.getTGuestNumList = res.bean;
        });
      },
      // 获取台帐table数据
      getTableList(params) {
        this.$services.postLoading({
          type: 'GUESTBUSINESS',
          url: 'OW_WEB_Qry_TransferGoods',
          params,
        }).then(res => {
          this.tableData = res.bean.map(item => {
            item.uid = this.$utils.getUid();
            item.IsScullFee = item.IsScullFee === true ? '是' : '否';
            item.IsScullRight = item.IsScullRight === true ? '是' : '否';
            item.IsLimit = item.IsLimit === true ? '是' : '否';
            // item.State = this.itmeState[String(item.State)];
            return item;
          });
          if (this.tableData[0]) {
            this.total = this.tableData[0].OWTableCounts;
          }
          else {
            this.total = 0;
            this.currentPage = 1;
          }
          this.$refs.spTable.initTable();
        });
      },
      // 台帐参数处理
      getTableParams(start) {
        let params = {
          startPos: this.currentPage,
          pageSize: this.pageSize,
          accountId: this.userInfor.accountId,
          dateTimeType: 'createDate',
          beginDate: '2019-01-01 00:00:00',
          endDate: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
        };
        if (!start) {
          let fromData = _.cloneDeep(this.$refs.queryList.fromData);
          if (fromData.state[0]) {
            params.state = fromData.state.join(',');
          }
          if (fromData.beginDate) {
            params.beginDate = fromData.beginDate;
            delete fromData.beginDate;
          }
          // if (!fromData.goodsName) fromData.goodsId = '';
          for (let i in fromData) {
            if (!fromData[i] || typeof fromData[i] === 'object') {
              delete fromData[i];
            }
          }
          Object.assign(params, fromData);
        }
        this.getTableList(params);
      },
      // 用户勾选数据
      handleSelectionChange(val) {
        this.userChoice = val;
        let RevokeRE = true, DelRE = true, editRE = true, commitRE = true;
        val.forEach(v => {
          if (v.State !== 2) {
            this.disableBtnRevoke = true;
            RevokeRE = false;
          }
          if (v.State !== 0) {
            this.disableBtnDel = true;
            DelRE = false;
          }
          if (v.State !== 0) {
            this.disableBtnedit = true;
            editRE = false;
            this.disableBtncommit = true;
            commitRE = false;
          }
        });

        RevokeRE ? this.disableBtnRevoke = false : '';
        DelRE ? this.disableBtnDel = false : '';
        editRE ? this.disableBtnedit = false : '';
        commitRE ? this.disableBtncommit = false : '';
      },
      // 详情
      operationInfoEven() {
        if (this.userChoice.length > 1 || this.userChoice.length === 0) {
          this.$message({
            type: 'warning',
            message: '请选择一条数据查看',
          });
          return false;
        }
        this.titleChange('adminCargoTransferDetail');
        this.$router.push({
          name: 'adminCargoTransferDetail',
          query: {
            id: this.userChoice[0].BillID,
            type: 'info',
            MainOrder: this.userChoice[0].TransferGoodsID
          }
        });
      },
      titleChange(path) {
        this.visitedViews.forEach(v => {
          v.name.indexOf(path) > -1 && v.title.indexOf('新增') > -1 ? v.title = v.title.replace(/新增/, '') + '详情' : '';
        });
      },
      // 添加
      operationAddEven() {
        this.$services.postLoading({
          type: 'ERP',
          url: 'getBillId',
          params: {
            tableId: 'TransferGoods',
            accountId: this.userInfor.accountId,
          },
        }).then(res => {
          let bean = JSON.parse(res.bean);
          let BillID = bean[0].BillID;
          let FieldValue = bean[0].FieldValue;
          this.$router.push({
            name: 'adminCargoTransferAdd',
            query: {id: BillID, type: 'add', MainOrder: FieldValue, WebType: 0,},
          });

        });
      },
      // 编辑
      operationEditEven() {
        if (this.userChoice.length > 1 || this.userChoice.length === 0) {
          this.$message({
            type: 'info',
            message: '请选择一条数据修改',
          });
          return false;
        }
        this.titleChange('adminCargoTransferDetail');
        this.$router.push({
          name: 'adminCargoTransferDetail',
          query: {
            id: this.userChoice[0].BillID,
            type: 'edit',
            MainOrder: this.userChoice[0].TransferGoodsID
          }
        });
      },
      //撤回
      operationRecallEven() {
        this.userChoice.forEach(itme => {
          this.$services.postLoading({
            type: 'GUESTBUSINESS',
            url: 'orderRevoke',
            params: {
              billId: itme.BillID,
              accountId: this.userInfor.accountId,
            },
          }).then(res => {
            if (typeof res.bean === 'string') {
              let bean = JSON.parse(res.bean);
              if (bean.RetMessage) {
                this.$message({
                  message: JSON.parse(res.bean).RetMessage,
                  type: 'warning',
                });
              }
            }
            else if (res.bean[0].RetCode == 100) {
              this.$message({
                message: '撤回成功！',
                type: 'success',
              });
              this.getTableParams(false);
            }
          });
        });
      },
      // 审核
      doAudit() {
        this.userChoice.forEach(itme => {
          this.$services.post({
            type: 'ERP',
            url: 'doAudit',
            params: {
              pProId: 100001,
              aAccountId: this.userInfor.accountId,
              aTableId: 'TransferGoods',
              aBillId: itme.BillID,
              aAuditStep: 0,
              pFuncId: 296,
              aOperatorId: this.userInfor.id,
              pAccountId: this.userInfor.accountId,
            },
          }).then(res => {
            if (typeof res.bean === 'string') {
              let bean = JSON.parse(res.bean);
              if (bean.RetMessage) {
                this.$message({
                  message: JSON.parse(res.bean).RetMessage,
                  type: 'warning',
                });
              }
              else {
                this.$message({
                  message: '审核成功！',
                  type: 'success',
                });
              }
            }
            this.getTableParams(false);
            this.$forceUpdate();
          });

        });

      },
      // 提交
      operationDeleteEven() {
        this.userChoice.forEach(itme => {
          this.$services.postLoading({
            type: 'ERP',
            url: 'doBlankOut',
            params: {
              aAccountId: this.userInfor.accountId,
              aTableId: 'TransferGoods',
              aBillId: itme.BillID,
              aAuditStep: '',
              pFuncId: 296,
              aOperatorId: this.userInfor.id,
              pAccountId: '',
              pProId: 100022,
            },
          }).then(res => {
            res.code === '000' ? this.$message({
              message: '作废成功！',
              type: 'success',
            }) : '';
            if (typeof res.bean === 'string') {
              let bean = JSON.parse(res.bean);
              if (bean.RetMessage) {
                this.$message({
                  message: JSON.parse(res.bean).RetMessage,
                  type: 'warning',
                });
              }
            }
            this.getTableParams(false);
            this.$forceUpdate();
          });
        });
      },
      initCol() {
        this.CargoTransfer.length > 0
        && (this.colList = this.CargoTransfer.map(itme => {
            let info = itme;
            info.field = itme.fieldName;
            info.title = itme.fieldAlias;
            info.width = itme.displayWidth;
            info.sortableStart = false;
            return info;
          })
        );
      },
    },
    watch: {
      CargoTransfer() {
        this.initCol();
      },
      colList(val) {
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      },
    },
  };
</script>
<style lang="scss">
  .standing {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .adminCargoTransfer {
    .el-table__body-wrapper {
      height: calc(100% - 53px);
    }
  }
</style>
